// extracted by mini-css-extract-plugin
export default {"reactPlayer__wrapper":"Player_reactPlayer__wrapper__R8T8M","reactPlayer__video":"Player_reactPlayer__video__y6Nfj"};